import { healthAt, lateAfterMs, stoppedAfterMs, type HealthDto } from "@nabla/api";

interface Deps {
  readonly now: () => number;
  readonly after: (ms: number, run: () => void) => () => void;
  readonly changed: () => void;
}

export function createHealth(deps: Deps) {
  let held: HealthDto | undefined;
  let stop: (() => void) | undefined;
  const put = (said: HealthDto | undefined) => {
    stop?.();
    const now = deps.now();
    held = said && healthAt(said, now);
    const beat = said?.lastBeatAt === undefined ? Number.NaN : Date.parse(said.lastBeatAt);
    const turns = [beat + lateAfterMs, beat + stoppedAfterMs].find((at) => at > now);
    stop = said === undefined || turns === undefined ? undefined : deps.after(turns - now, () => put(said));
    deps.changed();
  };
  return { get: () => held, put };
}
